import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider } from '../../shared/kit';
import App from './App';
import type { MemberRegistrationInitData } from './types';
import './wizard.css';

const mountEl = document.getElementById('gas-member-registration-react-app');

if (mountEl?.dataset.reactInit) {
    let initData: MemberRegistrationInitData = {};

    try {
        initData = JSON.parse(mountEl.dataset.reactInit || '{}') as MemberRegistrationInitData;
    } catch (error) {
        mountEl.innerHTML = '';
        throw error;
    }

    if (mountEl.isConnected) {
        createRoot(mountEl).render(
            <React.StrictMode>
                <GasQueryProvider>
                    <App initData={initData} />
                </GasQueryProvider>
            </React.StrictMode>,
        );
    }
}
